module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_DROPDOWN_ICON.b2d3683e.svg";